module.exports = "pegasus_template/assets/themecapture1/health/105.png";